
import Symbol from 'core-js/es6/symbol';

const _ = require('lodash');
const ko = require('knockout');
const $ = require('jquery');

// NOTE: Do not use jquery plugin to apply mask.
// 'inputmask' and old 'jquery.inputmask' use the same extender name.
import {default as Inputmask} from 'rgs-jquery-inputmask';


const VALUE_BACKUP_EMPTY = Symbol('VALUE_BACKUP_EMPTY');


// jquery.inputmask binding
// TODO: `jqInputmask`, it's `value`-compat code and `jqInputmaskUnmaskedValue` are too intertwined
// TODO: Some inputmask bugs have been fixed and workarounds that are not necessary should be removed
ko.bindingHandlers.jqInputmask = {
	after: [ 'value', 'jqInputmaskForceUpdateFromModel' ],
	
	init: function (element, valueAccessor, allBindings) {
		const $element = $(element);

		if (allBindings.has('value')) {
			const updateFromModel = function () {
				const newValue = ko.unwrap(allBindings.get('value')) || '';
				const elementValue = $element.val() || '';

				const valueHasChanged = (newValue !== elementValue);

				if (allBindings['has']('jqInputmaskForceUpdateFromModel') || valueHasChanged){
					$element.val(newValue);
				} else if (newValue === '' || newValue === undefined || newValue === null) {
					// Workaround for bug when $element.val() appear 'onFocus' even if it
					// was set to '' before focus event
					$element.val('');
				}
			};

			ko.computed(updateFromModel, null, { disposeWhenNodeIsRemoved: element });

			// This is a workaround for https://github.com/RobinHerbots/jquery.inputmask/issues/1228
			// inputmask triggers change asynchronously so we have to catch the `blur`
			$element.on('blur', function () {
				const observable = allBindings.get('value');
				const elementValue = $element.val();
				const modelValue = observable.peek();

				const valueHasChanged = (modelValue !== elementValue);

				if (ko.isWritableObservable(observable) && valueHasChanged) {
					observable(elementValue);
				}
			});
		}
	},
	update: function (element, valueAccessor, allBindings) {
		const $element = $(element);
		const mask = ko.unwrap(valueAccessor());

		let valueBackup = VALUE_BACKUP_EMPTY;
		if (allBindings.has('value')) {
			ko.ignoreDependencies(function () {
				valueBackup = ko.unwrap(allBindings.get('value'));
			}, this);
		} else if (allBindings.has('jqInputmaskUnmaskedValue')) {
			ko.ignoreDependencies(function () {
				valueBackup = ko.unwrap(allBindings.get('jqInputmaskUnmaskedValue'));
			}, this);
		}

		Inputmask(mask).mask(element);

		if (valueBackup !== VALUE_BACKUP_EMPTY) {
			$element.val(valueBackup);
		}
	},
};

ko.bindingHandlers.jqInputmaskUnmaskedValue = {
	after: [ 'jqInputmask' ],
	init: function (element, valueAccessor, allBindings) {
		const $element = $(element);

		const updateFromModel = function () {
			const newValue = ko.unwrap(valueAccessor()) || '';
			const elementValue = $element.inputmask('unmaskedvalue') || '';

			const valueHasChanged = (newValue !== elementValue);

			if (valueHasChanged) {
				$element.val(newValue);
			}
		};

		ko.computed(updateFromModel, null, { disposeWhenNodeIsRemoved: element });

		const updateFromDom = function () {
			const observable = valueAccessor();
			const elementValue = $element.inputmask('unmaskedvalue');
			const modelValue = observable.peek();

			const valueHasChanged = (modelValue !== elementValue);

			if (ko.isWritableObservable(observable) && valueHasChanged) {
				observable(elementValue);
			}
		};

		// This is a workaround for https://github.com/RobinHerbots/jquery.inputmask/issues/1228
		// inputmask triggers change asynchronously so we have to catch the `blur`
		$element.on('blur', updateFromDom);

		if (allBindings.has('jqInputmaskUnmaskedValueUpdate')) {
			const AFTER = 'after';
			const events = allBindings.get('jqInputmaskUnmaskedValueUpdate');
			_.each(events, (e) => {
				let handler = updateFromDom;
				if (e.startsWith(AFTER)) {
					e = e.slice(AFTER.length);
					handler = _.partial(_.defer, handler);
				}
				$element.on(e, handler);
			});
		}
	},
};
